import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { esPA } from '@cumpli/shared';

// Default and only locale: es-PA (§9). All copy lives in the shared catalog.
void i18n.use(initReactI18next).init({
  lng: 'es-PA',
  fallbackLng: 'es-PA',
  resources: { 'es-PA': { translation: esPA } },
  interpolation: { escapeValue: false },
});

export default i18n;
